import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { StyledIcon, SvgSrc } from '~/components/shared/Icon/Icon';
import { MediaQueries } from '~/constants/constVars';
import { formatAmount } from '~/helpers/formatters.helper';
import useTranslate from '~/hooks/useTranslate';
import { Instalment } from '~/Interfaces';

export const InstalmentRow = styled.div<{
  whiteBackground?: boolean;
  isOnInvoiceView?: boolean;
}>`
  line-height: 20px;
  display: flex;
  flex-direction: row;
  padding: 16px;
  background: #F8F9F5;
  height: 55px
  margin: 5px 0 5px 0;
  font-weight: 600;
  @media ${MediaQueries.smallScreen} {
     ${(props) =>
       props.isOnInvoiceView &&
       css`
         font-size: 13px;
       `}
  }
  ${(props) =>
    props.whiteBackground &&
    css`
    background-color: white;
    height: 35px
    color: #757575;
    font-weight: 400;
  `}
  `;

export const InstalmentData = styled.div<{
  firstColumn?: boolean;
  secondColumn?: boolean;
  thirdColumn?: boolean;
}>`
  ${(props) =>
    props.firstColumn &&
    css`
      width: 50%;
      @media ${MediaQueries.smallScreen} {
        width: 65%;
      }
    `}
  ${(props) =>
    props.secondColumn &&
    css`
      width: 40%;
      text-align: right;
      @media ${MediaQueries.smallScreen} {
        width: 25%;
      }
    `}
  ${(props) =>
    props.thirdColumn &&
    css`
      width: 10%;
      text-align: right;
      @media ${MediaQueries.smallScreen} {
        padding-left: 10px;
      }
    `}
`;

export const OrderNumber = styled.span`
  min-width: 15px;
  display: inline-block;
`;

export const InstalmentDate = styled.span`
  margin-right: 5px;
  display: inline-block;
`;

export const ExpandButton = styled.button`
  width: 30px;
  height: 30px;
  background-color: #f8f9f5;
  border: none;
  padding-bottom: 10px;
`;

interface Props {
  instalment: Instalment;
  isOnInvoiceView?: boolean;
}

const Card: React.FC<Props> = (props) => {
  const { instalment, isOnInvoiceView } = props;
  const translate = useTranslate();

  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <div>
      <InstalmentRow isOnInvoiceView={isOnInvoiceView}>
        <InstalmentData firstColumn>
          <OrderNumber> {instalment.index}. </OrderNumber>
          <InstalmentDate>
            {' '}
            {`${translate('Due').toString().replace(':', '')} ${
              instalment.plannedDate
            }`}
          </InstalmentDate>
        </InstalmentData>
        <InstalmentData secondColumn>
          {formatAmount(+instalment.annuityAmount)}
        </InstalmentData>
        <InstalmentData thirdColumn>
          <ExpandButton onClick={() => setExpanded(!expanded)}>
            <StyledIcon
              color="#444444"
              icon={expanded ? SvgSrc.ChevronUp : SvgSrc.ChevronDown}
            />
          </ExpandButton>
        </InstalmentData>
      </InstalmentRow>
      {expanded && (
        <>
          <InstalmentRow whiteBackground isOnInvoiceView={isOnInvoiceView}>
            <InstalmentData firstColumn>
              {translate('Invoices.Instalment')}
            </InstalmentData>
            <InstalmentData secondColumn>
              {formatAmount(+instalment.annuityInstalment)}
            </InstalmentData>
            <InstalmentData thirdColumn>{}</InstalmentData>
          </InstalmentRow>
          <InstalmentRow whiteBackground isOnInvoiceView={isOnInvoiceView}>
            <InstalmentData firstColumn>
              {translate('Invoices.Fee')}
            </InstalmentData>
            <InstalmentData secondColumn>
              {formatAmount(+instalment.annuityInterest)}
            </InstalmentData>
            <InstalmentData thirdColumn>{}</InstalmentData>
          </InstalmentRow>
        </>
      )}
    </div>
  );
};

export default Card;
